import axios, { AxiosResponse } from 'axios'

import { VendorUserRoles, NotificationFrequency } from 'common/server/server_types'
import {
  AcceptInvite,
  ForgotPassword,
  ResendConfirmation,
  ResetPassword,
  SignIn,
  SignOut,
  Flags,
} from 'common/server/user'

import { Vendor } from 'vendor/server/vendor_settings/vendor'

export interface ShowUserResponse {
  id: string
  name: string
  first_name: string
  last_name: string
  email: string
  role: VendorUserRoles
  vendor_id: string
  is_subbase: boolean
  vendor: Vendor
  terms_and_conditions: {
    terms_and_conditions_approved_on: string
    url: string
  }
  impersonating: boolean
  is_public: boolean
  headline?: string
  daily_reminder_email: boolean
  feature_flags: Flags
  permissions: string[]
}

export interface UserEditOptions {
  first_name?: string
  last_name?: string
  terms_and_conditions_approved: boolean
}

export interface UserPersonalInformationEditOptions {
  first_name: string
  last_name: string
  is_public: boolean
  headline?: string
}

export interface UserNotificationFrequency {
  notification_frequency: NotificationFrequency
  daily_reminder_email: boolean
}

export interface UserPasswordEditOptions {
  current_password?: string
  password?: string
  password_confirmation?: string
}

// Authenticate
export const sign_in: SignIn = function (payload) {
  return axios.post('/vendor/users/sign_in', { vendor_user: payload })
}

export const sign_out: SignOut = function () {
  return axios.delete('/vendor/users/sign_out')
}

export const forgot_password: ForgotPassword = function forgot_password(email) {
  return axios.post('/vendor/users/password/', { vendor_user: { email } })
}

export const reset_password: ResetPassword = function reset_password(
  password,
  password_confirmation,
  reset_password_token,
) {
  return axios.patch('/vendor/users/password', {
    vendor_user: { password, password_confirmation, reset_password_token },
  })
}

export const resend_confirmation: ResendConfirmation = function (email) {
  return axios.post('/vendor/users/confirmation', { vendor_user: { email } })
}

export const accept_invite: AcceptInvite = function (payload) {
  return axios.put('/vendor/users/invitation', { vendor_user: payload })
}

// User
export function update(
  payload: UserEditOptions | UserPersonalInformationEditOptions | UserPasswordEditOptions | UserNotificationFrequency,
) {
  return axios.put('/vendor/users', { vendor_user: payload })
}

export function show(): Promise<AxiosResponse<ShowUserResponse>> {
  return axios.get('/vendor/users')
}
